export default __webpack_public_path__ + "static/media/Group 2575.1f78f23b.png";